<template>
    <div class="index-container">
        <top-section>ERROR 403</top-section>
        <div class="inner-content">
            <p>You are not authorized to view this page</p>
        </div>
    </div>
</template>
<script>
export default {
}
</script>